/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon16Regular = forwardRef('ArrowDim1VIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m7.25 2.811-2.22 2.22A.75.75 0 0 1 3.97 3.97l2.793-2.793a1.75 1.75 0 0 1 2.474 0L12.03 3.97a.75.75 0 0 1-1.06 1.06L8.75 2.81v10.38l2.22-2.22a.75.75 0 1 1 1.06 1.06l-2.793 2.793a1.75 1.75 0 0 1-2.474 0L3.97 12.03a.75.75 0 0 1 1.06-1.06l2.22 2.219V2.81Z" })));
});
